function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlane = function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.3 45c-1.8 0-3.3-1.5-3.3-3.3h0V29h-6.8l-2.7 4.8c-.6 1.1-2.1 1.5-3.2.9-.8-.4-1.3-1.2-1.3-2.1V15.4C3 14.1 4.1 13 5.4 13c.9 0 1.6.5 2.1 1.2l2.7 4.8H17V6.3C17 4.5 18.5 3 20.3 3c1.3 0 2.4.7 3 1.8L30.5 19H40c2.8 0 5 2.2 5 5s-2.2 5-5 5h-9.5l-7.2 14.2c-.6 1.1-1.8 1.8-3 1.8",
    style: {
      fill: "#fe8400",
      stroke: "#fe8400",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
};
export default SvgPlane;